// @flow
import React, { Component } from 'react';
import SimpleBar from 'simplebar';
import 'simplebar/dist/simplebar.css';

class Scrollable extends Component {
    bindRef: Function;
    _simpleBar: any;
    _scrollable: any;

    constructor(props: any) {
        super(props);

        this.bindRef = this.bindRef.bind(this);
    }

    componentDidMount() {
        this._simpleBar = new SimpleBar(this._scrollable);
    }

    componentDidUpdate() {
        this._simpleBar = new SimpleBar(this._scrollable);
    }

    componentWillUnmount() {
        SimpleBar.removeObserver();
    }

    bindRef(c: any) {
        this._scrollable = c;
    }

    render() {
        const { additionalClassName, children } = this.props;

        const cls = additionalClassName
            ? `scrollable ${additionalClassName}`
            : 'scrollable';

        return (
            <div className={cls} ref={this.bindRef}>
                {children}
            </div>
        );
    }
}

export default Scrollable;



// WEBPACK FOOTER //
// ./src/components/shared/Scrollable.js